import firebase from "firebase/app";
import "firebase/database";

const firebaseConfig = {
    apiKey: "AIzaSyAQMunDnb3cXeIZPTW0cImQB5GPvymD4aY",
    authDomain: "contact-form-cf72e.firebaseapp.com",
    projectId: "contact-form-cf72e",
    storageBucket: "contact-form-cf72e.appspot.com",
    messagingSenderId: "941508497412",
    appId: "1:941508497412:web:9d63044a91f9029a922551"
  
};

//const firebaseApp = firebase.initializeApp(firebaseConfig);

//const db = firebaseApp.database();

//const auth = firebase.auth();

const fireDb = firebase.initializeApp(firebaseConfig);


export default fireDb.database().ref();